// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Product selector — palette and type are taken from the existing Metronic
 * admin (brand #008fc7) so the dialog reads as part of the product, not a
 * transplant. The one deliberate addition is the selection tray.
 */
:host {
  --ps-brand: #008fc7;
  --ps-brand-dark: #004661;
  --ps-brand-tint: #e8f5fb;
  --ps-ink: #48465b;
  --ps-muted: #6c7293;
  --ps-line: #ebedf2;
  --ps-rail: #f7f8fa;
  --ps-danger: #fd397a;
}

.ps-shell {
  border: 0;
  border-radius: 6px;
  box-shadow: 0 20px 60px rgba(31, 33, 44, 0.24);
  overflow: hidden;
}

/* ------------------------------------------------------------------ header */

.ps-header {
  align-items: flex-start;
  border-bottom: 1px solid var(--ps-line);
  padding: 20px 24px 16px;
}

.ps-title {
  color: var(--ps-ink);
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
}

.ps-hint {
  color: var(--ps-muted);
  font-size: 12.5px;
  margin: 4px 0 0;
}

.ps-header__aside {
  align-items: center;
  display: flex;
  gap: 16px;
}

.ps-count {
  background: var(--ps-brand-tint);
  border-radius: 20px;
  color: var(--ps-brand-dark);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  padding: 5px 12px;
  white-space: nowrap;
}

.ps-count strong {
  font-weight: 600;
}

.ps-count--zero {
  background: var(--ps-rail);
  color: var(--ps-muted);
}

.ps-close {
  background: none;
  border: 0;
  color: var(--ps-muted);
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  padding: 6px;
}

.ps-close:hover {
  color: var(--ps-ink);
}

/* ----------------------------------------------------------------- filters */

.ps-toolbar {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 24px;
}

.ps-field {
  position: relative;
}

.ps-field--search {
  flex: 1 1 260px;
}

.ps-field--categories {
  flex: 1 1 260px;
}

.ps-field__icon {
  color: var(--ps-muted);
  font-size: 12px;
  left: 14px;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.ps-input {
  background: #fff;
  border: 1px solid var(--ps-line);
  border-radius: 4px;
  color: var(--ps-ink);
  font-size: 13px;
  height: 38px;
  padding: 0 12px 0 34px;
  width: 100%;
}

.ps-input::placeholder {
  color: var(--ps-muted);
}

.ps-input:focus {
  border-color: var(--ps-brand);
  box-shadow: 0 0 0 3px rgba(0, 143, 199, 0.14);
  outline: none;
}

:host ::ng-deep .ps-select .ng-select-container {
  border: 1px solid var(--ps-line);
  border-radius: 4px;
  color: var(--ps-ink);
  font-size: 13px;
  min-height: 38px;
}

:host ::ng-deep .ps-select.ng-select-focused .ng-select-container {
  border-color: var(--ps-brand);
  box-shadow: 0 0 0 3px rgba(0, 143, 199, 0.14);
}

:host ::ng-deep .ps-select .ng-value {
  background: var(--ps-brand-tint) !important;
  border-radius: 3px;
  color: var(--ps-brand-dark) !important;
}

/* -------------------------------------------------------------------- tray */

.ps-tray {
  align-items: center;
  background: var(--ps-rail);
  border-top: 1px solid var(--ps-line);
  border-bottom: 1px solid var(--ps-line);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 24px;
}

.ps-tray__label {
  color: var(--ps-muted);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.ps-chips {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 6px;
  list-style: none;
  margin: 0;
  max-height: 96px;
  overflow-y: auto;
  padding: 0;
}

.ps-chip {
  align-items: center;
  background: #fff;
  border: 1px solid var(--ps-line);
  border-radius: 3px;
  display: inline-flex;
  gap: 6px;
  max-width: 220px;
  padding: 3px 4px 3px 9px;
}

.ps-chip__name {
  color: var(--ps-ink);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ps-chip__remove {
  background: none;
  border: 0;
  border-radius: 2px;
  color: var(--ps-muted);
  cursor: pointer;
  font-size: 9px;
  line-height: 1;
  padding: 3px 4px;
}

.ps-chip__remove:hover {
  background: var(--ps-danger);
  color: #fff;
}

.ps-tray__more,
.ps-tray__clear {
  background: none;
  border: 0;
  cursor: pointer;
  font-size: 12px;
  padding: 3px 6px;
}

.ps-tray__more {
  color: var(--ps-brand);
  font-weight: 500;
}

.ps-tray__clear {
  color: var(--ps-muted);
  margin-left: auto;
}

.ps-tray__clear:hover {
  color: var(--ps-danger);
}

/* ------------------------------------------------------------------- table */

.ps-body {
  padding: 0;
  position: relative;
}

.ps-table-wrap {
  max-height: 46vh;
  overflow: auto;
}

.ps-loader {
  background: var(--ps-brand-tint);
  height: 2px;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 3;
}

.ps-loader::after {
  animation: ps-slide 1.1s ease-in-out infinite;
  background: var(--ps-brand);
  content: "";
  display: block;
  height: 100%;
  width: 40%;
}

@keyframes ps-slide {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(300%); }
}

:host ::ng-deep .ps-table th.mat-mdc-header-cell {
  background: #fff;
  border-bottom: 1px solid var(--ps-line);
  color: var(--ps-muted);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  padding: 10px 12px;
  text-transform: uppercase;
}

:host ::ng-deep .ps-table td.mat-mdc-cell {
  border-bottom: 1px solid var(--ps-line);
  color: var(--ps-ink);
  font-size: 13px;
  padding: 10px 12px;
}

:host ::ng-deep .ps-table .ps-col-check {
  padding-left: 20px;
  width: 48px;
}

:host ::ng-deep .ps-table .ps-col-flag {
  text-align: center;
  width: 130px;
}

.ps-row {
  cursor: pointer;
}

:host ::ng-deep .ps-row:hover td.mat-mdc-cell {
  background: var(--ps-rail);
}

:host ::ng-deep .ps-row--selected td.mat-mdc-cell {
  background: var(--ps-brand-tint);
}

:host ::ng-deep .ps-row--open td.mat-mdc-cell,
:host ::ng-deep .ps-row--selected td.mat-mdc-cell {
  border-bottom-color: transparent;
}

:host ::ng-deep .ps-detail-row {
  height: 0;
}

:host ::ng-deep .ps-detail-cell {
  padding: 0 !important;
}

.ps-detail {
  background: var(--ps-rail);
  overflow: hidden;
}

.ps-check {
  accent-color: var(--ps-brand);
  cursor: pointer;
  height: 15px;
  margin: 0;
  vertical-align: middle;
  width: 15px;
}

.ps-check:focus-visible {
  outline: 2px solid var(--ps-brand);
  outline-offset: 2px;
}

.ps-name {
  align-items: center;
  display: flex;
  gap: 8px;
  min-width: 0;
}

.ps-name__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ps-expand {
  background: none;
  border: 0;
  border-radius: 3px;
  color: var(--ps-muted);
  cursor: pointer;
  flex: 0 0 auto;
  font-size: 10px;
  height: 20px;
  line-height: 1;
  padding: 0;
  width: 20px;
}

.ps-expand:hover {
  background: #fff;
  color: var(--ps-brand);
}

.ps-expand--empty {
  display: inline-block;
  visibility: hidden;
}

.ps-badge {
  background: var(--ps-rail);
  border-radius: 10px;
  color: var(--ps-muted);
  flex: 0 0 auto;
  font-size: 10.5px;
  padding: 2px 8px;
}

.ps-flag {
  align-items: center;
  background: var(--ps-rail);
  border-radius: 50%;
  color: var(--ps-muted);
  display: inline-flex;
  font-size: 10px;
  height: 22px;
  justify-content: center;
  width: 22px;
}

.ps-flag--on {
  background: var(--ps-brand-tint);
  color: var(--ps-brand-dark);
}

/* Variation rows mirror the parent column grid so nothing drifts. */
.ps-varrow {
  align-items: center;
  border-top: 1px solid var(--ps-line);
  cursor: pointer;
  display: grid;
  grid-template-columns: 48px 1fr 130px 130px;
  padding: 8px 0;
}

.ps-varrow:hover {
  background: #fff;
}

.ps-varrow .ps-col-check {
  padding-left: 20px;
}

.ps-varrow .ps-col-flag {
  text-align: center;
}

.ps-varrow__name {
  align-items: center;
  color: var(--ps-ink);
  display: flex;
  font-size: 12.5px;
  gap: 8px;
  min-width: 0;
  padding-inline-start: 28px;
}

.ps-varrow__tick {
  background: var(--ps-line);
  flex: 0 0 auto;
  height: 1px;
  width: 10px;
}

/* ------------------------------------------------------- empty / bulk / foot */

.ps-empty {
  color: var(--ps-muted);
  padding: 48px 24px;
  text-align: center;
}

.ps-empty i {
  font-size: 26px;
  opacity: 0.5;
}

.ps-empty__title {
  color: var(--ps-ink);
  font-size: 14px;
  margin: 12px 0 4px;
}

.ps-linkbtn {
  background: none;
  border: 0;
  color: var(--ps-brand);
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 500;
  padding: 2px 4px;
  text-decoration: underline;
}

.ps-linkbtn:disabled {
  color: var(--ps-muted);
  cursor: default;
}

.ps-bulk {
  align-items: center;
  background: var(--ps-brand-tint);
  color: var(--ps-brand-dark);
  display: flex;
  flex-wrap: wrap;
  font-size: 12.5px;
  gap: 6px;
  justify-content: center;
  padding: 9px 24px;
}

:host ::ng-deep .ps-paginator {
  background: transparent;
  border-top: 1px solid var(--ps-line);
}

.ps-footer {
  align-items: center;
  border-top: 1px solid var(--ps-line);
  display: flex;
  justify-content: space-between;
  padding: 14px 24px;
}

.ps-footer__meta {
  color: var(--ps-muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.ps-done {
  background: var(--ps-brand);
  border: 0;
  color: #fff;
  font-weight: 500;
  min-width: 104px;
}

.ps-done:hover {
  background: var(--ps-brand-dark);
  color: #fff;
}

.ps-done:focus-visible {
  box-shadow: 0 0 0 3px rgba(0, 143, 199, 0.3);
  outline: none;
}

/* ----------------------------------------------------------------- responsive */

@media (max-width: 767px) {
  .ps-header,
  .ps-toolbar,
  .ps-tray,
  .ps-bulk,
  .ps-footer {
    padding-left: 16px;
    padding-right: 16px;
  }

  .ps-table-wrap {
    max-height: 52vh;
  }

  :host ::ng-deep .ps-table .ps-col-flag {
    width: 84px;
  }

  .ps-varrow {
    grid-template-columns: 44px 1fr 84px 84px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ps-loader::after {
    animation: none;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/product-selector/product-selector.component.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;EACE,uBAAuB;EACvB,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA,8EAA8E;;AAE9E;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,8EAA8E;;AAE9E;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,8EAA8E;;AAE9E;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA,gFAAgF;;AAEhF;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,aAAa;AACf;;AAEA,iFAAiF;;AAEjF;EACE;;;;;IAKE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":["/*\n * Product selector — palette and type are taken from the existing Metronic\n * admin (brand #008fc7) so the dialog reads as part of the product, not a\n * transplant. The one deliberate addition is the selection tray.\n */\n:host {\n  --ps-brand: #008fc7;\n  --ps-brand-dark: #004661;\n  --ps-brand-tint: #e8f5fb;\n  --ps-ink: #48465b;\n  --ps-muted: #6c7293;\n  --ps-line: #ebedf2;\n  --ps-rail: #f7f8fa;\n  --ps-danger: #fd397a;\n}\n\n.ps-shell {\n  border: 0;\n  border-radius: 6px;\n  box-shadow: 0 20px 60px rgba(31, 33, 44, 0.24);\n  overflow: hidden;\n}\n\n/* ------------------------------------------------------------------ header */\n\n.ps-header {\n  align-items: flex-start;\n  border-bottom: 1px solid var(--ps-line);\n  padding: 20px 24px 16px;\n}\n\n.ps-title {\n  color: var(--ps-ink);\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.ps-hint {\n  color: var(--ps-muted);\n  font-size: 12.5px;\n  margin: 4px 0 0;\n}\n\n.ps-header__aside {\n  align-items: center;\n  display: flex;\n  gap: 16px;\n}\n\n.ps-count {\n  background: var(--ps-brand-tint);\n  border-radius: 20px;\n  color: var(--ps-brand-dark);\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n\n.ps-count strong {\n  font-weight: 600;\n}\n\n.ps-count--zero {\n  background: var(--ps-rail);\n  color: var(--ps-muted);\n}\n\n.ps-close {\n  background: none;\n  border: 0;\n  color: var(--ps-muted);\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1;\n  padding: 6px;\n}\n\n.ps-close:hover {\n  color: var(--ps-ink);\n}\n\n/* ----------------------------------------------------------------- filters */\n\n.ps-toolbar {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 16px 24px;\n}\n\n.ps-field {\n  position: relative;\n}\n\n.ps-field--search {\n  flex: 1 1 260px;\n}\n\n.ps-field--categories {\n  flex: 1 1 260px;\n}\n\n.ps-field__icon {\n  color: var(--ps-muted);\n  font-size: 12px;\n  left: 14px;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.ps-input {\n  background: #fff;\n  border: 1px solid var(--ps-line);\n  border-radius: 4px;\n  color: var(--ps-ink);\n  font-size: 13px;\n  height: 38px;\n  padding: 0 12px 0 34px;\n  width: 100%;\n}\n\n.ps-input::placeholder {\n  color: var(--ps-muted);\n}\n\n.ps-input:focus {\n  border-color: var(--ps-brand);\n  box-shadow: 0 0 0 3px rgba(0, 143, 199, 0.14);\n  outline: none;\n}\n\n:host ::ng-deep .ps-select .ng-select-container {\n  border: 1px solid var(--ps-line);\n  border-radius: 4px;\n  color: var(--ps-ink);\n  font-size: 13px;\n  min-height: 38px;\n}\n\n:host ::ng-deep .ps-select.ng-select-focused .ng-select-container {\n  border-color: var(--ps-brand);\n  box-shadow: 0 0 0 3px rgba(0, 143, 199, 0.14);\n}\n\n:host ::ng-deep .ps-select .ng-value {\n  background: var(--ps-brand-tint) !important;\n  border-radius: 3px;\n  color: var(--ps-brand-dark) !important;\n}\n\n/* -------------------------------------------------------------------- tray */\n\n.ps-tray {\n  align-items: center;\n  background: var(--ps-rail);\n  border-top: 1px solid var(--ps-line);\n  border-bottom: 1px solid var(--ps-line);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px 24px;\n}\n\n.ps-tray__label {\n  color: var(--ps-muted);\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.ps-chips {\n  display: flex;\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  gap: 6px;\n  list-style: none;\n  margin: 0;\n  max-height: 96px;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.ps-chip {\n  align-items: center;\n  background: #fff;\n  border: 1px solid var(--ps-line);\n  border-radius: 3px;\n  display: inline-flex;\n  gap: 6px;\n  max-width: 220px;\n  padding: 3px 4px 3px 9px;\n}\n\n.ps-chip__name {\n  color: var(--ps-ink);\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ps-chip__remove {\n  background: none;\n  border: 0;\n  border-radius: 2px;\n  color: var(--ps-muted);\n  cursor: pointer;\n  font-size: 9px;\n  line-height: 1;\n  padding: 3px 4px;\n}\n\n.ps-chip__remove:hover {\n  background: var(--ps-danger);\n  color: #fff;\n}\n\n.ps-tray__more,\n.ps-tray__clear {\n  background: none;\n  border: 0;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 3px 6px;\n}\n\n.ps-tray__more {\n  color: var(--ps-brand);\n  font-weight: 500;\n}\n\n.ps-tray__clear {\n  color: var(--ps-muted);\n  margin-left: auto;\n}\n\n.ps-tray__clear:hover {\n  color: var(--ps-danger);\n}\n\n/* ------------------------------------------------------------------- table */\n\n.ps-body {\n  padding: 0;\n  position: relative;\n}\n\n.ps-table-wrap {\n  max-height: 46vh;\n  overflow: auto;\n}\n\n.ps-loader {\n  background: var(--ps-brand-tint);\n  height: 2px;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 3;\n}\n\n.ps-loader::after {\n  animation: ps-slide 1.1s ease-in-out infinite;\n  background: var(--ps-brand);\n  content: \"\";\n  display: block;\n  height: 100%;\n  width: 40%;\n}\n\n@keyframes ps-slide {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(300%); }\n}\n\n:host ::ng-deep .ps-table th.mat-mdc-header-cell {\n  background: #fff;\n  border-bottom: 1px solid var(--ps-line);\n  color: var(--ps-muted);\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  padding: 10px 12px;\n  text-transform: uppercase;\n}\n\n:host ::ng-deep .ps-table td.mat-mdc-cell {\n  border-bottom: 1px solid var(--ps-line);\n  color: var(--ps-ink);\n  font-size: 13px;\n  padding: 10px 12px;\n}\n\n:host ::ng-deep .ps-table .ps-col-check {\n  padding-left: 20px;\n  width: 48px;\n}\n\n:host ::ng-deep .ps-table .ps-col-flag {\n  text-align: center;\n  width: 130px;\n}\n\n.ps-row {\n  cursor: pointer;\n}\n\n:host ::ng-deep .ps-row:hover td.mat-mdc-cell {\n  background: var(--ps-rail);\n}\n\n:host ::ng-deep .ps-row--selected td.mat-mdc-cell {\n  background: var(--ps-brand-tint);\n}\n\n:host ::ng-deep .ps-row--open td.mat-mdc-cell,\n:host ::ng-deep .ps-row--selected td.mat-mdc-cell {\n  border-bottom-color: transparent;\n}\n\n:host ::ng-deep .ps-detail-row {\n  height: 0;\n}\n\n:host ::ng-deep .ps-detail-cell {\n  padding: 0 !important;\n}\n\n.ps-detail {\n  background: var(--ps-rail);\n  overflow: hidden;\n}\n\n.ps-check {\n  accent-color: var(--ps-brand);\n  cursor: pointer;\n  height: 15px;\n  margin: 0;\n  vertical-align: middle;\n  width: 15px;\n}\n\n.ps-check:focus-visible {\n  outline: 2px solid var(--ps-brand);\n  outline-offset: 2px;\n}\n\n.ps-name {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  min-width: 0;\n}\n\n.ps-name__text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ps-expand {\n  background: none;\n  border: 0;\n  border-radius: 3px;\n  color: var(--ps-muted);\n  cursor: pointer;\n  flex: 0 0 auto;\n  font-size: 10px;\n  height: 20px;\n  line-height: 1;\n  padding: 0;\n  width: 20px;\n}\n\n.ps-expand:hover {\n  background: #fff;\n  color: var(--ps-brand);\n}\n\n.ps-expand--empty {\n  display: inline-block;\n  visibility: hidden;\n}\n\n.ps-badge {\n  background: var(--ps-rail);\n  border-radius: 10px;\n  color: var(--ps-muted);\n  flex: 0 0 auto;\n  font-size: 10.5px;\n  padding: 2px 8px;\n}\n\n.ps-flag {\n  align-items: center;\n  background: var(--ps-rail);\n  border-radius: 50%;\n  color: var(--ps-muted);\n  display: inline-flex;\n  font-size: 10px;\n  height: 22px;\n  justify-content: center;\n  width: 22px;\n}\n\n.ps-flag--on {\n  background: var(--ps-brand-tint);\n  color: var(--ps-brand-dark);\n}\n\n/* Variation rows mirror the parent column grid so nothing drifts. */\n.ps-varrow {\n  align-items: center;\n  border-top: 1px solid var(--ps-line);\n  cursor: pointer;\n  display: grid;\n  grid-template-columns: 48px 1fr 130px 130px;\n  padding: 8px 0;\n}\n\n.ps-varrow:hover {\n  background: #fff;\n}\n\n.ps-varrow .ps-col-check {\n  padding-left: 20px;\n}\n\n.ps-varrow .ps-col-flag {\n  text-align: center;\n}\n\n.ps-varrow__name {\n  align-items: center;\n  color: var(--ps-ink);\n  display: flex;\n  font-size: 12.5px;\n  gap: 8px;\n  min-width: 0;\n  padding-inline-start: 28px;\n}\n\n.ps-varrow__tick {\n  background: var(--ps-line);\n  flex: 0 0 auto;\n  height: 1px;\n  width: 10px;\n}\n\n/* ------------------------------------------------------- empty / bulk / foot */\n\n.ps-empty {\n  color: var(--ps-muted);\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.ps-empty i {\n  font-size: 26px;\n  opacity: 0.5;\n}\n\n.ps-empty__title {\n  color: var(--ps-ink);\n  font-size: 14px;\n  margin: 12px 0 4px;\n}\n\n.ps-linkbtn {\n  background: none;\n  border: 0;\n  color: var(--ps-brand);\n  cursor: pointer;\n  font-size: 12.5px;\n  font-weight: 500;\n  padding: 2px 4px;\n  text-decoration: underline;\n}\n\n.ps-linkbtn:disabled {\n  color: var(--ps-muted);\n  cursor: default;\n}\n\n.ps-bulk {\n  align-items: center;\n  background: var(--ps-brand-tint);\n  color: var(--ps-brand-dark);\n  display: flex;\n  flex-wrap: wrap;\n  font-size: 12.5px;\n  gap: 6px;\n  justify-content: center;\n  padding: 9px 24px;\n}\n\n:host ::ng-deep .ps-paginator {\n  background: transparent;\n  border-top: 1px solid var(--ps-line);\n}\n\n.ps-footer {\n  align-items: center;\n  border-top: 1px solid var(--ps-line);\n  display: flex;\n  justify-content: space-between;\n  padding: 14px 24px;\n}\n\n.ps-footer__meta {\n  color: var(--ps-muted);\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n}\n\n.ps-done {\n  background: var(--ps-brand);\n  border: 0;\n  color: #fff;\n  font-weight: 500;\n  min-width: 104px;\n}\n\n.ps-done:hover {\n  background: var(--ps-brand-dark);\n  color: #fff;\n}\n\n.ps-done:focus-visible {\n  box-shadow: 0 0 0 3px rgba(0, 143, 199, 0.3);\n  outline: none;\n}\n\n/* ----------------------------------------------------------------- responsive */\n\n@media (max-width: 767px) {\n  .ps-header,\n  .ps-toolbar,\n  .ps-tray,\n  .ps-bulk,\n  .ps-footer {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .ps-table-wrap {\n    max-height: 52vh;\n  }\n\n  :host ::ng-deep .ps-table .ps-col-flag {\n    width: 84px;\n  }\n\n  .ps-varrow {\n    grid-template-columns: 44px 1fr 84px 84px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ps-loader::after {\n    animation: none;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
